var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"overflow-x-auto",attrs:{"id":"app","dark":""}},[_c('notifications'),(_vm.isNavigation)?_c('navigation',{staticClass:"flex-shrink-0 flex-grow-0"}):_vm._e(),_c('v-main',{staticClass:"overflow-auto flex-grow-1 fill-height"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }